import { useNavigate } from 'react-router-dom'
import StepWizard from 'react-step-wizard'
import styled from 'styled-components'

import { IconCloseLarge } from 'assets/svg/sprite'
import { Loader } from 'components/Loader/Loader'
import { VerificationNavbar } from 'components-ref/organisms/verification'
import {
    VerificationCountry,
    VerificationPersonalInformation,
    VerificationUploadImages,
    VerificationVerifyMyIdentity
} from 'components-ref/templates/verification'
import { useUserProfile } from 'store'

export const ModelVerification = () => {
    const userData = useUserProfile()
    const navigate = useNavigate()

    if (!userData) return <Loader />

    const creatorApplicationStep = userData.creator_application_step ?? 0

    const initialStep = !userData.avatar?.url
        ? 1
        : creatorApplicationStep >= 4
            ? 4
            : creatorApplicationStep >= 2
                ? creatorApplicationStep + 1
                : 2

    function handleClose() {
        navigate('/following')
    }

    return (
        <Wrapper>
            <Close onClick={handleClose}>
                <IconCloseLarge />
            </Close>

            <Container
                nav={<VerificationNavbar />}
                initialStep={initialStep}
                isLazyMount={true}
                isHashEnabled={false}
                onStepChange={() => {
                    window.scrollTo(0, 0)
                }}
            >
                <VerificationUploadImages />
                <VerificationCountry />
                <VerificationVerifyMyIdentity />
                <VerificationPersonalInformation
                    verificationStep={creatorApplicationStep}
                />
            </Container>
        </Wrapper>
    )
}


const Container = styled(StepWizard)`
    height: 100%;

    .rsw_2Y,
    .rsw_2Y > * {
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .rsw_2Y::-webkit-scrollbar,
    .rsw_2Y > *::-webkit-scrollbar {
        width: 5px;
    }

    .rsw_2Y::-webkit-scrollbar-track,
    .rsw_2Y > *::-webkit-scrollbar-track {
        background: transparent;
        margin-block: 1.2rem;
    }

    .rsw_2Y::-webkit-scrollbar-thumb,
    .rsw_2Y > *::-webkit-scrollbar-thumb {
        background: #c2c2c2;
        border-radius: 999px;
    }

    .rsw_2Y::-webkit-scrollbar-thumb:hover,
    .rsw_2Y > *::-webkit-scrollbar-thumb:hover {
        background: #b8b8b8;
    }

    .rsw_2Y::-webkit-scrollbar-button,
    .rsw_2Y > *::-webkit-scrollbar-button {
        display: none;
        width: 0;
        height: 0;
    }
`
const Wrapper = styled.div`
    max-width: 80rem;
    height: 100%;
    margin: auto;
    padding: 6rem 0;
    position: relative;
`
const Close = styled.div`
    position: absolute;
    top: 2rem;
    right: 2rem;
`
